import { AxiosError } from 'axios'
import { useSelector } from 'react-redux'
import {
    UseQueryOptions,
    useQuery,
} from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import {
    TUserServiceError,
    TCounterHistoryProps,
    TCounterHistoryResponse,
} from 'services/UserService'
import { QueryCacheKeys } from 'enums'
import { UserService } from 'services'
import * as userSelectors from 'containers/User/user-selectors'
import { getRequestError } from 'utils/helpers'

export type TFetchFnParams = TCounterHistoryProps
export type TFetchFnError = AxiosError<TUserServiceError, TFetchFnParams>
export type TError = [string, TFetchFnError]
export type TQueryKey = [string, TFetchFnParams]
export type TQueryFnOpts = UseQueryOptions<TCounterHistoryResponse, TError, TCounterHistoryResponse, TQueryKey>

const key = QueryCacheKeys.counterHistory

/**
 * Хук API получить данные каунтера
 */
export default function useFetchCounterHistory(params: TFetchFnParams, opts: TQueryFnOpts = {}) {
    const { t } = useTranslation()
    const user = useSelector(userSelectors.user)

    return useQuery([`${key}-${user.id}`, params], () => {
        return UserService.fetchCounterHistory(params)
            .then(({ data }) => {
                return data
            })
            .catch((err) => {
                return Promise.reject([getRequestError(err) || t('update_error'), err])
            })
    }, opts)
}
